import { render, staticRenderFns } from "./SrReportExpiringContracts.vue?vue&type=template&id=1820a604&"
import script from "./SrReportExpiringContracts.vue?vue&type=script&lang=js&"
export * from "./SrReportExpiringContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports